export * from './Binder.js';
export * from './BinderRoot.js';
export * from './BinderNode.js';
export * from './Field.js';
export * from './Models.js';
export * from './Validation.js';
export * from './Validators.js';
export * from './Validity.js';

// @ts-expect-error: esbuild injection
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
((feature, vaadinObj = (globalThis.Vaadin ??= {})) => {
  vaadinObj.registrations ??= [];
  vaadinObj.registrations.push({
    is: feature ? `@vaadin/hilla-lit-form/${feature}` : '@vaadin/hilla-lit-form',
    version: '24.9.21',
  });
})();
